module.exports = __webpack_public_path__ + "img/bigONotation.95f4b970.svg";